import uikit from '../uikit';

import {create as createVideoDesk} from '../components/VideoDesk/VideoDesk';
import {createEngineerMessageView} from '../components/Engineer/EngineerMessageView';

export class VideoDeskEntryPoint extends uikit.EntryPoint {

  initialize() {
    _.defer(() => {
      uikit.components.register(createVideoDesk, { priority: false });
    }); 
    uikit.components.register(createEngineerMessageView, { priority: false });     
  }

}



// WEBPACK FOOTER //
// ./assets/entryPoints/VideoDeskEntryPoint.js